import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import Last_week_ledger from "./last_week_ledger";
import Last_week_cash_book from "./last_week_cash_book";
import Last_week_ledger_accounts from "./last_week_ledger_accounts";
import { Toast } from '../components_root/ToastContext';
import { MdArrowBackIos, MdClose } from "react-icons/md";
import Last_week_log_history from "./last_week_log_history";
import Cash_books_log from "./cash_book_root/cash_books_log.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Accounting_data() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const servicetablename = "accountingfinancedb";
    return (
        <div>

            <div className="b-bottom"  >
                <table  >
                    <tr >

                        <td className="text-h1 p-11 fcap ">Monitor</td>
                        <td width={30}>
                            <div onClick={() => {
                                navigate("/accounting");


                            }} className="button-ui0 p-2 cursor"><MdClose className="icon" /></div>

                        </td>
                    </tr>

                </table>
            </div>
            <div className='post-container'>
                <div className="post_div p-1">
                    <div className="ui-grid">
                        <div className="ui-items b-1 rounded">
                            <Last_week_cash_book />
                        </div>
                        <div className="ui-items b-1 rounded">
                            <Last_week_ledger />
                        </div>
                        <div className="ui-items b-1 rounded">
                            <Last_week_ledger_accounts />
                        </div>
                        <div className="ui-items b-1 rounded">
                            <Last_week_log_history />
                        </div>


                    </div>
                    <br />
                    <Cash_books_log />
                </div>

            </div>
        </div>
    );
}
